import Axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Button, Image, Modal } from 'react-bootstrap';

interface Props {
  year: string;
  barcode: string;
}

export const ImagePreview = (props: any) => {
  const [visible, setVisible] = useState(false);
  const [imageUrl, setImageUrl] = useState('');
  const [error, setError] = useState(false);
  const fy = props.year.substring(2)
  const fetchImageUrl = async () => {
    try {
      let image = await Axios.get(`${(window as any)._env_.REACT_APP_SERVER}/request/getS3InventoryDownload`, {
        params: { barcode: props.barcode, year: props.year },
      });
      setImageUrl(image.data.url);
    } catch (err) {
      console.log('Error: /frontend/src/pages/InventoryPage/ImagePreview//index', err);
    }
  };

  useEffect(() => {
    fetchImageUrl();
  }, []);

  return (
    <div>
      <Button onClick={() => setVisible(true)} variant='info' size='sm'>
        <i className='fa fa-image' />
      </Button>
      <Modal scrollable={false} dialogClassName='inventory-image-modal' show={visible} onHide={() => setVisible(false)}>
        {/* <Modal.Header closeButton /> */}
        <Modal.Title className='form-inline mt-3'>
          <div className='col-sm-9'>
            <h3>{error ? `No image available for FY${fy}!` : 'Preview Item Image'}</h3>
          </div>
          <div className='col-sm-3'>
            <div className='form-inline float-right'>
             {!error &&  <Button href={imageUrl} variant='info' className='mr-2'>
                <i className='fa fa-download' />
              </Button>}
              <Button variant='primary' onClick={() => setVisible(false)}>
                <i className='fa fa-times' />
              </Button>
            </div>
          </div>
        </Modal.Title>
        <Modal.Body style={{ maxHeight: '100%' }}>
          {!error && <Image onError={() => setError(true)} placeholder='hello' src={imageUrl} fluid />}
          <Image />
        </Modal.Body>
      </Modal>
    </div>
  );
};
